import clsx from "clsx";
import { HTMLAttributes } from "react";

export interface TableBodyProps extends HTMLAttributes<HTMLTableSectionElement> {
  /**
   * The final tbody HTML must contain only tr children. Non-DOM wrappers like Context.Provider are allowed.
   */
  children: React.ReactNode;
}

export const TableBody = ({ children, className, ...props }: TableBodyProps) => (
  <tbody className={clsx("bg-white", className)} {...props}>
    {children}
  </tbody>
);
